import { render, staticRenderFns } from "./PaperOfferEdit.vue?vue&type=template&id=2e9768b4"
import script from "./PaperOfferEdit.vue?vue&type=script&lang=js"
export * from "./PaperOfferEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports